'use client';

import Image from 'next/image';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer
      id="footer"
      className="relative flex w-full flex-col items-center justify-center gap-4 bg-[#121212] px-5 py-6 [&>*]:tracking-[-0.5px]"
    >
      {/* Footer Content Inner */}
      <div className="block w-full text-left">
        {/* Top Section */}
        <div className="flex w-full items-center justify-between">
          <Image
            src="/images/common/logo_new_white.svg"
            alt="KottonSeed"
            width={95}
            height={20}
            className="h-5 w-[95px]"
          />
          <div className="flex gap-2 text-[0]">
            <a href="https://www.instagram.com/kottonseed" target="_blank" rel="noopener noreferrer">
              <Image src="/images/icon/ico_instagram.svg" alt="instagram" width={36} height={36} />
            </a>
          </div>
        </div>

        {/* Address Section */}
        <div className="flex flex-col gap-1 pt-5" data-nosnippet>
          <p className="typo-body-6 text-white">롯데이노베이트(주)</p>
          <p className="break-keep typo-caption-1 text-text-caption-1">대표이사 : 김경엽</p>
          <p className="break-keep typo-caption-1 text-text-caption-1">
            08500 서울특별시 금천구 가산디지털2로 179(가산동, 롯데센터)
          </p>
          <p className="break-keep typo-caption-1 text-text-caption-1">사업자등록번호 : 687-81-00785</p>
          <p className="break-keep typo-caption-1 text-text-caption-1">통신판매업신고번호 : 제 2017-서울금천-1395 호</p>
          <p className="break-keep typo-caption-1 text-text-caption-1">
            이메일 :{' '}
            <Link href="/support/qna/write" className="break-keep typo-caption-1 text-text-caption-1">
              kottonseed_support@lotte.net
            </Link>
          </p>
          <p className="typo-caption-2 text-text-caption-1">
            (메뉴{'>'}SUPPORT{'>'}1:1 문의를 통해 더 빠른 응대가 가능합니다.)
          </p>
          <p className="typo-caption-2 text-text-caption-2">
            롯데이노베이트(주)는 통신판매중개자로서 오픈마켓 코튼시드의 거래당사자가 아니며, 판매자가 등록한 상품정보 및 거래에 대해
            롯데이노베이트(주)는 일체 책임을 지지 않습니다.
          </p>
        </div>
      </div>

      {/* Line */}
      <div className="h-0 w-full max-w-[1280px] border-[0.3px] border-solid border-[#ffffff31]" />

      {/* Copyright */}
      <div className="relative mx-auto flex w-full max-w-[1280px] items-center justify-between">
        <p className="text-left typo-caption-2 text-white">
          Copyright&copy;LOTTE INNOVATE COMPANY . All rights Reserved.
        </p>
      </div>

      {/* Footer Utility Links */}
      <div className="flex w-full justify-start">
        <ul className="flex flex-wrap gap-x-4 gap-y-3">
          <li className="w-[calc(50%-8px)] leading-none h-5">
            <Link href="/support/faq/list" className="typo-body-4 text-white">
              FAQ
            </Link>
          </li>
          <li className="w-[calc(50%-8px)] leading-none h-5">
            <Link href="/policy/privacy" className="typo-body-4 text-[#8424EA]">
              개인정보 처리방침
            </Link>
          </li>
          <li className="w-[calc(50%-8px)] leading-none h-5">
            <Link href="/policy/service" className="typo-body-4 text-white">
              서비스 이용약관
            </Link>
          </li>
          <li className="w-[calc(50%-8px)] leading-none h-5">
            <Link href="/policy/recurring-payment" className="typo-body-4 text-white">
              정기결제 이용약관
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
}
